import { Theme, ThemedText } from '@app/theme';
import { addCommasToNumber } from '@app/utils';
import { useTheme } from '@shopify/restyle';
import { View, Text, StyleSheet } from 'react-native';

const AmountCard = ({
    availableCreditAmount,
    totalPortfolioAmount
}: {
    availableCreditAmount: number,
    totalPortfolioAmount: number
}) => {
  const {colors} = useTheme<Theme>()
  return (
    <View style={[styles.card, {backgroundColor: colors['bg-fill-primary']}]}>
      {/* Credit Limit Section */}
      <View style={[styles.topSection, {backgroundColor: colors['bg-fill-primary']}]}>
        <ThemedText 
            variant='b4r' 
            color='text-secondary'
        >
            Available credit limit
        </ThemedText>
        <ThemedText
            variant='h1b'
            color='text-success'
        >
          <ThemedText fontFamily='Inter' variant='h1b' color='text-success'>₹</ThemedText>
            {availableCreditAmount && addCommasToNumber(availableCreditAmount)}
        </ThemedText>
      </View>
      
      {/* Divider takes full width of parent */}
      <View style={styles.divider} />
      
      {/* Mutual Funds Section with different background */}
      <View style={[styles.bottomSection, {backgroundColor: colors['bg-fill-info']}]}>
        <ThemedText 
            variant='b4r' 
            color='text-secondary'
        >
            Fetched mutual funds
        </ThemedText>
        <ThemedText
            variant='h5b'
            color='text-primary'
        >
          <ThemedText fontFamily='Inter' variant='h5b' color='text-primary'>₹ </ThemedText>
            {totalPortfolioAmount && addCommasToNumber(totalPortfolioAmount)}
        </ThemedText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    // backgroundColor: 'white',
    borderRadius: 16,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    width: '100%',
    alignSelf: 'center',
  },
  topSection: {
      borderWidth: 1,
    borderColor: '#E5E7EB',
    borderBottomWidth:0,
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    // Ensures the top section has rounded corners
  },
  bottomSection: {
    borderWidth: 1,
    borderColor: '#E5E7EB',
    borderTopWidth:0,
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
  },
  label: {
    fontSize: 16,
    color: '#6B7280',
    fontWeight: '400',
    marginBottom: 8,
  },
  creditAmount: {
    fontSize: 38,
    fontWeight: '700',
    color: '#4CAF50', // Green color for credit amount
  },
  mutualFundsAmount: {
    fontSize: 32,
    fontWeight: '700',
    color: '#000000', // Black color for mutual funds amount
  },
  divider: {
    height: 1,
    backgroundColor: '#E5E7EB',
    width: '100%', // Full width of the parent container
  },
});

export default AmountCard;

// Example usage in App.js:
// 
// import React from 'react';
// import { SafeAreaView, StatusBar } from 'react-native';
// import FinancialCard from './components/FinancialCard';
// 
// const App = () => {
//   return (
//     <SafeAreaView style={{ flex: 1, backgroundColor: '#F3F4F6', justifyContent: 'center' }}>
//       <StatusBar barStyle="dark-content" />
//       <FinancialCard />
//     </SafeAreaView>
//   );
// };
// 
// export default App;